import React from "react";

import { GroupButtons } from "../../../../../components/button/GroupButtons";
import { Button } from "../../../../../components/newUI/button";
import { CloudSvg } from "../../../../../components/svg/CloudSvg";
import PlusSvg from "../../../../../components/svg/PlusSvg";
import { TaskTemplatesListHeaderProps } from "../model/taskTemplatesList.types";

export const TaskTemplatesListHeader: React.FC<
  TaskTemplatesListHeaderProps
> = ({
  activeStatus,
  isImporting,
  onStatusChange,
  onImport,
  onCreate,
  onBuildWithAi,
}) => (
  <div className={"mb-6 flex items-center justify-between gap-4 font-Manrope"}>
    <div className={"text-2xl font-semibold"}>Subtask Templates</div>

    <div className={"flex gap-4"}>
      <GroupButtons
        buttons={[
          {
            label: "All",
            action: () => onStatusChange("all"),
            isActive: activeStatus === "all",
          },
          {
            label: "Active",
            action: () => onStatusChange("active"),
            isActive: activeStatus === "active",
          },
          {
            label: "Inactive",
            action: () => onStatusChange("inactive"),
            isActive: activeStatus === "inactive",
          },
        ]}
      />

      <div className={"flex gap-3"}>
        <Button
          type={"button"}
          variant={"outline"}
          autoWidth
          disabled={isImporting}
          leftIcon={<CloudSvg />}
          onClick={onImport}
          className={
            "border-[#C8D2DE] px-4 text-[#253747] hover:border-[#C8D2DE] hover:bg-white"
          }>
          Import Template
        </Button>

        {onBuildWithAi && (
          <Button
            type={"button"}
            variant={"outline"}
            autoWidth
            onClick={onBuildWithAi}
            className={
              "border-[#6938EF] px-4 text-[#6938EF] hover:border-[#6938EF] hover:bg-[#F4F1FF]"
            }>
            ✨ Build with AI
          </Button>
        )}

        <Button
          type={"button"}
          autoWidth
          leftIcon={<PlusSvg />}
          onClick={onCreate}
          className={
            "border-[#6938EF] bg-[#6938EF] px-4 text-white hover:border-[#6938EF] hover:bg-[#6938EF]"
          }>
          New Template
        </Button>
      </div>
    </div>
  </div>
);
